<template>
   <div class="uploadResources_wrap">
       <el-tabs type="border-card">
            <el-tab-pane>
                <span slot="label"><i class="el-icon-coin"></i> 公共数据</span>
                <div class="public_data">
                    <div class="formTitle">
                        公共数据表单
                    </div>
                    <div class="form_wrap">
                        <el-form ref="publicForm" :model="publicData" label-width="200px">
                            <el-form-item label="选择数据类型:">
                                <div class="select_wrap">
                                    <el-select v-model="publicData.dataType">
                                        <el-option v-for="item in publicDataSelect" :key="item.id" :label="item.value" :value="item.id"></el-option>
                                    </el-select>
                                </div>
                            </el-form-item>
                            <el-form-item label="输入数据名称:">
                                <el-input placeholder="请输入数据名称" v-model="publicData.dataTitle"></el-input>
                            </el-form-item>
                            <el-form-item label="上传外部预览图:">
                                <el-upload
                                    class="upload-demo"
                                    action="https://jsonplaceholder.typicode.com/posts/"
                                    :on-success="uploadPoster"
                                    :show-file-list="false">
                                    <el-button type="primary">添加图片</el-button><span style="color:#F56C6C">&nbsp;&nbsp;(请上传分辨率为480*260的png、jpg图片)</span>
                                    <div slot="tip" class="el-upload__tip">再次添加将覆盖掉之前的图片</div>
                                    <img v-if="posterImg" :src="posterImg" class="avatar">
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="输入数据简介:">
                                <el-input type="textarea" :autosize="{minRows:8}"  v-model="publicData.brief"></el-input>
                            </el-form-item>
                            <el-form-item label="字段描述:">
                                <el-button type="primary">模板下载</el-button>
                                <el-button type="primary">模板上传</el-button>
                            </el-form-item>
                            <div class="table_wrap" >
                                <el-table  border :header-cell-style="$core.tableHeader"  stripe header-align="center" :data="publicData.tableData">
                                    <el-table-column width="80" align="center" type="index" label="序号"></el-table-column>
                                    <el-table-column align="center" label="字段名"></el-table-column>
                                    <el-table-column align="center" label="数据类型"></el-table-column>
                                    <el-table-column align="center" label="描述"></el-table-column>
                                </el-table>
                            </div>
                            <el-form-item label="数据示例:">
                                <el-upload
                                  class="upload-demo"
                                  action="https://jsonplaceholder.typicode.com/posts/"
                                  :on-success="uploadImgList"
                                  :on-remove="handleRemove"
                                  :file-list="imgList"
                                  list-type="picture">
                                  <el-button type="primary">添加图片</el-button>
                                  <div slot="tip" class="el-upload__tip">此处可添加多张图片</div>
                                </el-upload>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </el-tab-pane>

            <el-tab-pane label="实时数据">
                <span slot="label"><i class="el-icon-set-up"></i> 案例系统</span>
                <div class="case_data">
                    <div class="formTitle">
                        实时数据表单
                    </div>
                    <div class="form_wrap">
                        <el-form ref="caseForm" :model="caseData" label-width="200px">
                            <el-form-item label="选择案例类型:">
                                <div class="select_wrap">
                                    <el-select v-model="caseData.dataType">
                                        <el-option v-for="item in publicDataSelect" :key="item.id" :label="item.value" :value="item.id"></el-option>
                                    </el-select>
                                </div>
                            </el-form-item>
                            <el-form-item label="输入案例标题:">
                                <el-input v-model="caseData.dataTitle" placeholder="请输入案例标题"></el-input>
                            </el-form-item>
                            <el-form-item label="上传外部预览图:">
                                <el-upload
                                    class="upload-demo"
                                    action="https://jsonplaceholder.typicode.com/posts/"
                                    :on-success="uploadPoster"
                                    :show-file-list="false">
                                    <el-button type="primary">添加图片</el-button><span style="color:#F56C6C">&nbsp;&nbsp;(请上传分辨率为270*150的png、jpg图片)</span>
                                    <div slot="tip" class="el-upload__tip">再次添加将覆盖掉之前的图片</div>
                                    <img v-if="posterImg" :src="posterImg" class="avatar">
                                </el-upload>
                            </el-form-item>
                            <el-form-item label="输入案例简介:">
                                <el-input type="textarea" placeholder="请输入案例简介，文字不能多于80字" :autosize="{minRows:5}" :show-word-limit="true" maxlength="80" v-model="caseData.brief"></el-input>
                            </el-form-item>
                            <el-form-item label="上传案例文件:">
                                <el-upload
                                  class="upload-demo"
                                  action="https://jsonplaceholder.typicode.com/posts/"
                                  :on-success="uploadImgList"
                                  :show-file-list="false">
                                  <el-button type="primary">上传文件</el-button>
                                  <span v-if="caseData.fileUrl"></span>
                                  <div slot="tip" class="el-upload__tip">请上传html文件，再次上传文件将覆盖之前的文件</div>
                                </el-upload>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </el-tab-pane>
        </el-tabs>
   </div>
</template>
<script>
import { getPublicMenu, queryCaseCategory } from '../../../utils/api';

export default {
    data() {
        return {
            posterImg: '',
            imgList: [],
            publicData: {
                dataType: '',
                dataTitle: '',
                poster: '',
                brief: '',
                tableData: [],
                    imgArray:[]
               },
               caseData:{
                    dataType:'',
                    dataTitle:'',
                    poster:'',
                    brief:'',
                    fileUrl:''
               },
               publicDataSelect:[{
                   id:0,
                   value:'金融数据'
               },{
                   id:1,
                   value:'经济数据'
               },{
                   id:2,
                   value:'旅游数据'
               },{
                   id:3,
                   value:'年鉴数据'
               },{
                   id:4,
                   value:'农村数据'
               },{
                   id:5,
                   value:'社会数据'
               }],
               caseDataSelect:[{
                   id:0,
                   value:'金融量价'
               },{
                   id:1,
                   value:'行业数据'
               },{
                   id:2,
                   value:'奇货可查'
               },{
                   id:3,
                   value:'另类数据'
               },{
                   id:4,
                   value:'高频数据'
               },{
                   id:5,
                   value:'学术专栏'
               }],
            }
          },
        mounted(){
            this.getMenu()
        },
        methods:{
            //获取公共数据目录和实时数据目录
            getMenu(){
                getPublicMenu().then(res => {

                }).catch(err => {})
                queryCaseCategory().then(res => {}).catch(err => {})
            },

            //移除图片
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },

            //上传图片组
            uploadImgList(response, file, fileList) {
                console.log(file,response,fileList);
            },

            //上传封面图片
            uploadPoster(response, file, fileList){
                this.posterImg = file.url
                console.log(file,response,fileList);
            }
        },
   }
</script>
<style lang='scss' scoped>
.case_data{
    text-align: center;
}
.public_data,.case_data{
    text-align: center;
    .form_wrap{
        .table_wrap{
            width: calc(74% - 200px);
            margin: 10px 0px 30px 200px;
        }
        .select_wrap{
            width: 250px;
        }
        /deep/.el-textarea{
            width: 70%;
        }
        /deep/.el-upload-list{
            width: 70%;
        }
        /deep/.el-form-item__label{
            color: #415CF4 ;
            font-weight: bold;
        }
        /deep/.el-input__inner{
            width: 250px;
        }
        /deep/.el-form-item__content{
            text-align: left;
        }
    }
}
.formTitle{
    font-size: 25px;
    margin: 20px auto;
    font-weight: 600;
    color: #415CF4
}
.uploadResources_wrap{
    box-sizing: border-box;
    padding: 50px 200px;
}
</style>
